import React from 'react';
import {GOOGLE_KEY} from '../context/constants';
import {GoogleMap,withScriptjs,withGoogleMap,Marker} from 'react-google-maps'
import Geocode from "react-geocode";
Geocode.setApiKey(GOOGLE_KEY);
const MapGoogle = React.memo(function MapGoogle({coordinates,setCoordinates,setAddress}) {
  const onMArkerDragEnd=(event)=>{
    const lat=event.latLng.lat(),lng=event.latLng.lng()
    setCoordinates({
      lat:lat,
      lng:lng
    })
    Geocode.fromLatLng(lat,lng)
      .then(res=>{
        const dir=res.results[0].formatted_address;
        setAddress(dir)
      
      })
  }
    const Map= () => {
        return ( 
            <GoogleMap 
            defaultZoom={17} 
            defaultCenter={{lat:40.416690,lng:-3.700340}} 
            center={{lat:coordinates.lat,lng:coordinates.lng}} 
            
            >
              <Marker
               draggable={true} 
               position={{lat:coordinates.lat,lng:coordinates.lng}} 
               onDragEnd={onMArkerDragEnd}
               />
    
            </GoogleMap>
         );
    }
        const WrappedMap= withScriptjs(withGoogleMap(Map));
    return ( 
        <div style={{width:'100%',height:'400px',marginTop:0}} >
                
                <WrappedMap
                  googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_KEY}`}
                  loadingElement={<div style={{height:"100%"}}/>}
                  containerElement={<div style={{height:"100%"}}/>}
                  mapElement={<div style={{height:"100%"}}/>}
                />
    </div>
     );
});
 
export default MapGoogle;
    